import { Component } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'dhp-filter-items-no-result',
  templateUrl: './filter-items-no-result.html',
  imports: [TranslatePipe],
})
export class FilterItemsNoResult {}
